import { OfficeReviewAdapters } from '../adapters';
import { OfficeReviewsApi } from '../clients';

/**
 * One page of an office's reviews, mapped for the table.
 *
 * Thin on purpose — the fetch is in `clients`, the mapping is in `adapters`,
 * and this is the seam `useGetOfficeReviews` calls so the hook keeps no
 * knowledge of either. Unlike `Users/services/GetRecruiters` there is no source
 * choice to make here: the office/professional split is structural, made by
 * `Profile.js` picking a component, because it is the professional side that
 * must *not* reach this code at all.
 *
 * @param {Object} params
 * @param {string} params.officeId - The office whose reviews to list
 * @param {number} params.page - 1-based page index
 * @param {number} [params.limit] - Page size
 * @returns {Promise<import('../types/OfficeReview').IGetOfficeReviewsResult>}
 */
export const getOfficeReviews = async ({ officeId, page, limit }) => {
  const response = await OfficeReviewsApi.getOfficeReviews({ officeId, page, limit });

  return OfficeReviewAdapters.toGetOfficeReviewsResult(response);
};
